import { render } from "./shebei.vue?vue&type=template&id=5b1e1185&scoped=true"
import script from "./shebei.vue?vue&type=script&lang=js"
export * from "./shebei.vue?vue&type=script&lang=js"

import "./shebei.vue?vue&type=style&index=0&id=5b1e1185&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1e1185"]])

export default __exports__